module.exports = __webpack_public_path__ + "img/judy-prof.165f84de.jpg";